import { useEffect } from 'react'
import {
    FaTruck, FaIdCard, FaTag, FaBuilding, FaStore, FaUser,
    FaMapMarkerAlt, FaRoad, FaCity, FaMailBulk, FaEnvelope,
    FaAddressBook, FaPhoneAlt, FaTshirt, FaStickyNote, FaInfoCircle,
} from 'react-icons/fa'
import { formatCNPJ } from '../../../shared/functions/cnpjFormat'
import './ProviderSummaryModal.css'

function clothRuleLabel(row) {
    return row.scope === 'all' ? 'Todos os Tecidos' : (row.cloths || []).map((c) => c.name).join(', ')
}

const Field = ({ icon: Icon, label, value }) => (
    <div className="psm-field">
        <span className="psm-field-label">
            {Icon && <Icon size={11} />}
            {label}
        </span>
        <span className="psm-field-value">{value || '—'}</span>
    </div>
)

function ProviderSummaryModal({ provider, onClose }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    if (!provider) return null

    const contacts = provider.contacts || []
    const clothPurchaseRules = provider.clothPurchaseRules || []

    return (
        <div className="psm-overlay" onClick={onClose}>
            <div className="psm-box" onClick={(e) => e.stopPropagation()}>

                <button className="psm-close shd-modal-close" onClick={onClose}>X</button>

                {/* ── Header ── */}
                <div className="psm-header">
                    <div className="psm-header-top">
                        <div className="psm-header-icon"><FaTruck /></div>
                        <div>
                            <p className="psm-name">{provider.name}</p>
                            <span className="psm-accent" />
                        </div>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="psm-body">

                    <div className="psm-section">
                        <div className="psm-section-header">
                            <FaInfoCircle size={13} />
                            <span>Identificação</span>
                        </div>
                        <div className="psm-grid">
                            <Field icon={FaTag} label="Tipo" value={provider.personType === 'juridica' ? 'Pessoa Jurídica' : 'Pessoa Física'} />
                            {provider.personType === 'juridica' ? (
                                <>
                                    <Field icon={FaBuilding} label="Razão Social" value={provider.corporateName} />
                                    <Field icon={FaStore} label="Nome Fantasia" value={provider.fantasyName} />
                                    <Field icon={FaIdCard} label="CNPJ" value={formatCNPJ(provider.CNPJ)} />
                                </>
                            ) : (
                                <>
                                    <Field icon={FaUser} label="Nome Completo" value={provider.completeName} />
                                    <Field icon={FaIdCard} label="CPF" value={provider.CPF} />
                                </>
                            )}
                        </div>
                    </div>

                    <div className="psm-section">
                        <div className="psm-section-header">
                            <FaMapMarkerAlt size={13} />
                            <span>Endereço e Contato</span>
                        </div>
                        <div className="psm-grid">
                            <Field
                                icon={FaMapMarkerAlt}
                                label="Endereço"
                                value={[provider.address, provider.number].filter(Boolean).join(', ') + (provider.complement ? ` — ${provider.complement}` : '')}
                            />
                            <Field icon={FaRoad} label="Bairro" value={provider.district} />
                            <Field icon={FaCity} label="Cidade/UF" value={[provider.city, provider.state].filter(Boolean).join('/')} />
                            <Field icon={FaMailBulk} label="CEP" value={provider.cep} />
                            <Field icon={FaEnvelope} label="Email" value={provider.email} />
                        </div>
                    </div>

                    <div className="psm-section">
                        <div className="psm-section-header">
                            <FaAddressBook size={13} />
                            <span>Contatos</span>
                        </div>
                        {contacts.length > 0 ? (
                            <div className="psm-list">
                                {contacts.map((c, i) => (
                                    <div key={i} className="psm-list-row">
                                        <span className="psm-list-row-icon"><FaAddressBook size={12} /></span>
                                        <span className="psm-list-row-label">{c.name}</span>
                                        <span className="psm-list-row-value"><FaPhoneAlt size={10} />{c.phone}</span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="psm-empty">Nenhum contato cadastrado.</p>
                        )}
                    </div>

                    <div className="psm-section">
                        <div className="psm-section-header">
                            <FaTshirt size={13} />
                            <span>Regras de Compra por Tecido</span>
                        </div>
                        {clothPurchaseRules.length > 0 ? (
                            <div className="psm-list">
                                {clothPurchaseRules.map((row, i) => (
                                    <div key={i} className="psm-list-row">
                                        <span className="psm-list-row-icon"><FaTshirt size={12} /></span>
                                        <span className="psm-list-row-label">{clothRuleLabel(row)}</span>
                                        <span className="psm-list-row-value">
                                            {row.unit?.label}{row.minPurchaseValue ? ` — mínimo ${row.minPurchaseValue}` : ''}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="psm-empty">Nenhuma regra cadastrada.</p>
                        )}
                    </div>

                    {provider.obs && (
                        <div className="psm-section">
                            <div className="psm-section-header">
                                <FaStickyNote size={13} />
                                <span>Observações</span>
                            </div>
                            <p className="psm-description">{provider.obs}</p>
                        </div>
                    )}

                </div>

                <div className="psm-footer" />
            </div>
        </div>
    )
}

export default ProviderSummaryModal
